import React, { useState } from "react";
import ReactCodeInput from "react-code-input";
import AuthWrapper from "../../components/AuthWrapper";
import AuthButton from "../../components/button/AuthButton";
import { Link, useLocation } from "react-router-dom/cjs/react-router-dom";
import { resendOtp, verifyOtp } from "../../api/verificationApi";
import toast from "react-hot-toast";
import { setUser } from "../../store/actions/actions";
import { useDispatch } from "react-redux";
import { getUserById } from "../../firebase/utility";
import { Button, Spinner } from 'reactstrap';
import ProfessionalLoader from "../../components/globals/ProfessionalLoader";

const VerifyCode = () => {
  const dispatch = useDispatch()
  const { state } = useLocation()
  const [loading, setLoading] = useState(false)
  const [resendloading, setResendLoading] = useState(false)
  const [codeExpires, setCodeExpires] = useState(false)
  const props = {
    className: ReactCodeInput,
    inputStyle: {
      fontFamily: "monospace",
      margin: "2px",
      MozAppearance: "textfield",
      width: "60px",
      height: "60px",
      borderRadius: "50%",
      fontSize: "28px",
      textAlign: "center",
      backgroundColor: "#F7F7F780",
      color: "lightskyblue",
      border: "1px solid gray",
    },
    inputStyleInvalid: {
      fontFamily: "monospace",
      margin: "4px",
      MozAppearance: "textfield",
      width: "15px",
      borderRadius: "3px",
      fontSize: "30px",
      height: "26px",
      padding: "7px",
      backgroundColor: "black",
      color: "red",
      border: "1px solid #F7F7F780",
    },
  };
  const [code, setCode] = useState("");
  const [inputKey, setInputKey] = useState(0)
  const handleChange = (code) => {
    setCode(code);
  };
  const handleVerify = () => {
    if (code.length < 6) {
      toast.error("Please enter the complete 6-digit code.");
      return;
    }
    let obj = { uid: state.uid, otp: code }
    setLoading(true)
    verifyOtp(obj, async (response) => {
      if (response?.status === 400) {
        toast.error(response?.message)
        setCode("")
        setInputKey(prev => prev + 1);
        setLoading(false)
      }
      if (response?.data?.success) {
        toast.success(response?.data?.message)
        let userId = response?.data?.user?.uid;
        const userData = await getUserById(userId, "Users");
        if (userData) {
          if (userData?.user?.profile_status === "disabled") {
            toast.error("You can't log in; your profile status is disabled.");
            setLoading(false);
            return;
          } else {
            dispatch(setUser(userData?.user));
          }
        }
      } else {
        setLoading(false);
      }
    })
  }
  const handleResend = () => {
    let obj = { uid: state.uid }
    setResendLoading(true)
    resendOtp(obj, async (response) => {
      if (response?.status === 400) {
        toast.error(response?.message)
        setResendLoading(false)
      }
      if (response?.data?.success) {
        toast.success(response?.data?.message)
        setResendLoading(false)
      }
    })
  }
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleVerify();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleVerify();
  };

  return (
    <>
      {loading && (
        <ProfessionalLoader
          text="Verifying Security Code"
          subtext="Securing your session and finalizing login..."
        />
      )}
      <AuthWrapper title={"Verify Your Identity"} description={"We've sent a 6-digit secure code to your email."}>
        <form onSubmit={handleSubmit} onKeyDown={handleKeyDown} className="d-flex justify-content-center flex-column align-items-center w-100">
          <div className="my-4" onKeyDown={handleKeyDown}>
            <ReactCodeInput
              key={inputKey}
              type="number"
              value={code}
              onChange={handleChange}
              fields={6}
              {...props}
            />
          </div>

          <div className="w-100 mt-2">
            <Button
              type="submit"
              className="w-100 rounded-3 border-0 py-2 shadow-sm text-white fw-600 mb-3"
              style={{
                background: "linear-gradient(90deg, #00509d, #182848)",
                height: "48px"
              }}
              onClick={handleVerify}
              disabled={loading}
            >
              Verify & Proceed
            </Button>

            <Button
              type="button"
              className="w-100 rounded-3 bg-white text-dark border-1 py-2 fw-600 mb-4"
              style={{
                border: "1px solid #e2e8f0",
                height: "48px"
              }}
              onClick={handleResend}
              disabled={resendloading}
            >
              {resendloading ? <Spinner size="sm" /> : "Resend Code"}
            </Button>
          </div>

          <div className="text-center mt-2">
            <Link to="/auth/login" className="text-decoration-none text-muted small fw-600">
              Return to <span className="text-primary">Login Page</span>
            </Link>
          </div>
        </form>
      </AuthWrapper>
    </>
  );
};

export default VerifyCode;


